// HAIKU — minimal borderless list. No toggles, no chrome: every answer is
// visible, set in generous whitespace with a staggered entrance reveal.
function itemHtml(ctx, it) {
    return `<div class="fq-item"${ctx.reveal(it.idx)}>
  <h3 class="fq-q">${it.q}</h3>
  <div class="fq-a">${it.aHtml}</div>
</div>`;
}
const haiku = {
    id: 'haiku',
    name: 'Haiku',
    tag: 'Minimal list',
    styleTag: 'Borderless',
    description: 'No borders, no toggles, no chrome \u2014 every answer visible, set in generous whitespace. For short FAQs that read like a page, not a widget.',
    layout: 'list',
    defaultAccent: '#0b2a46',
    darkDefault: false,
    catSupport: 'none',
    features: ['reveal'],
    render(ctx) {
        const html = `<div class="fq-wrap">
  <div class="fq-head">
    <h2 class="fq-title">${ctx.title}</h2>
    ${ctx.subtitle ? `<p class="fq-sub">${ctx.subtitle}</p>` : ''}
  </div>
  <div class="fq-list">
${ctx.items.map((it) => itemHtml(ctx, it)).join('\n')}
  </div>
</div>`;
        const css = `
.FQM .fq-wrap{max-width:620px;margin:0 auto}
.FQM .fq-head{margin:0 0 48px}
.FQM .fq-title{margin:0;font-family:${ctx.v.head};font-size:30px;font-weight:600;line-height:1.15;letter-spacing:-0.01em;color:${ctx.v.ink}}
.FQM .fq-sub{margin:10px 0 0;font-size:15.5px;line-height:1.6;color:${ctx.v.sub}}
.FQM .fq-list{display:flex;flex-direction:column;gap:40px}
.FQM .fq-q{margin:0 0 8px;font-size:18px;font-weight:600;line-height:1.4;color:${ctx.v.ink}}
.FQM .fq-a{font-size:15.5px;line-height:1.7;color:${ctx.v.sub}}
`;
        return { html, css };
    },
};
export default haiku;
